import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class TransitionService {
  public showGameLoader$ = new BehaviorSubject(false);
  public gameLoaderMessage$ = new BehaviorSubject('');

  constructor() { }

  public showGameLoader(message: string) {
    this.gameLoaderMessage$.next(message);
    this.showGameLoader$.next(true);
  }

  public hideGameLoader() {
    this.gameLoaderMessage$.next('');
    this.showGameLoader$.next(false);
  }

}
